import React from "react";
import { Link } from "react-router-dom";
import { getDateAgo } from "../../helper/Helper";

function Card({ item }) {
  return (
    <div className="blog-card">
      <Link to={`/blog/${item?.slug}`} className="blog-card-img-wrap">
        <img
          src={item?.image}
          alt={item?.title}
          loading="lazy"
          className="blog-card-img"
        />
        <div className="blog-card-img-overlay" />
        {item?.date && (
          <span className="blog-card-date-badge">{getDateAgo(item?.date)}</span>
        )}
      </Link>

      <div className="blog-card-body">
        <Link to={`/blog/${item?.slug}`} className="blog-card-title">
          {item?.title}
        </Link>
        <p className="blog-card-desc">{item?.shortDescription}</p>

        <div className="blog-card-footer">
          <Link to={`/blog/${item?.slug}`} className="blog-card-read-more">
            Read Story
            <svg viewBox="0 0 13 13" fill="none" stroke="currentColor" strokeWidth="1.5" width="13" height="13">
              <path d="M1 6.5h11M7 1l5.5 5.5L7 12" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
          <div className="blog-card-rule" aria-hidden="true" />
        </div>
      </div>
    </div>
  );
}

export default Card;